<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h4 class="modal-title">客戶資訊近期變更({{type}})，是否同步更新至CRM？</h4>
        </div>
        <div class="modal-body" v-if="open" :class="{'section-loading': isLoading}">
          <div class="customer-conetnt-wrapper">
            <div class="row item update-info" :class="{'is-isSync':customer.name.newValue}">
              <div class="col-9">
                <div class="row">
                  <div class="col-3 text-right mb-2">
                    <b>客戶姓名</b>
                  </div>
                  <div class="col-9 item-content mb-2">
                    <div class="content">
                      <span class="text">{{customer.name.value}}</span>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="customer.name.newValue">
                  <div class="col-3 text-right">
                    <span class="arrow m-0">❯</span>
                  </div>
                  <div class="col-9 item-content">
                    <div class="content">
                      <span class="text text-red">
                        <b class="text m-0 p-0">{{ customer.name.newValue}}</b>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="mr-0 checkbox checkbox-inline" v-if="customer.name.newValue">
                  <input type="checkbox" id="check-out-name" v-model="customer.name.isSync"/>
                  <label :for="`check-out-name`">同步更新</label>
                </div>
              </div>
            </div>

            <div class="row item update-info" :class="{'is-isSync':customer.identityID.newValue}">
              <div class="col-9">
                <div class="row">
                  <div class="col-3 text-right mb-2">
                    <b>身分證字號</b>
                  </div>
                  <div class="col-9 item-content mb-2">
                    <div class="content">
                      <span class="text">{{customer.identityID.value}}</span>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="customer.identityID.newValue">
                  <div class="col-3 text-right">
                    <span class="arrow m-0">❯</span>
                  </div>
                  <div class="col-9 item-content">
                    <div class="content">
                      <span class="text text-red">
                        <b class="text m-0 p-0">{{ customer.identityID.newValue}}</b>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <!--ID不給選-->
                <!--<div class="mr-0 checkbox checkbox-inline" v-if="customer.identityID.newValue">
                  <input type="checkbox" id="check-out-id" v-model="customer.identityID.isSync"/>
                  <label :for="`check-out-id`">同步更新</label>
                </div>-->
              </div>
            </div>

            <div class="row item update-info" :class="{'is-isSync':customer.birthday.newValue}">
              <div class="col-9">
                <div class="row">
                  <div class="col-3 text-right mb-2">
                    <b>生日</b>
                  </div>
                  <div class="col-9 item-content mb-2">
                    <div class="content">
                      <span class="text">{{customer.birthday.value|dateFormat}}</span>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="customer.birthday.newValue">
                  <div class="col-3 text-right">
                    <span class="arrow m-0">❯</span>
                  </div>
                  <div class="col-9 item-content">
                    <div class="content">
                      <span class="text text-red">
                        <b class="text m-0 p-0">{{customer.birthday.newValue|dateFormat }}</b>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="mr-0 checkbox checkbox-inline" v-if="customer.birthday.newValue" >
                  <input type="checkbox" id="check-out-birthday" v-model="customer.birthday.isSync"/>
                  <label :for="`check-out-birthday`">同步更新</label>
                </div>
              </div>
            </div>
            <div class="row item update-info" :class="{'is-isSync':customer.mobile.newValue}">
              <div class="col-9">
                <div class="row">
                  <div class="col-3 text-right mb-2">
                    <b>手機</b>
                  </div>
                  <div class="col-9 item-content mb-2">
                    <div class="content">
                      <span class="text">{{customer.mobile.value}}</span>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="customer.mobile.newValue">
                  <div class="col-3 text-right">
                    <span class="arrow m-0">❯</span>
                  </div>
                  <div class="col-9 item-content">
                    <div class="content">
                      <span class="text text-red">
                        <b class="text m-0 p-0">{{customer.mobile.newValue}}</b>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="mr-0 checkbox checkbox-inline" v-if="customer.mobile.newValue">
                  <input type="checkbox" id="check-out-mobile" v-model="customer.mobile.isSync"/>
                  <label :for="`check-out-mobile`">同步更新</label>
                </div>
              </div>
            </div>
            <div class="row item update-info" :class="{'is-isSync':customer.phone.newValue}">
              <div class="col-9">
                <div class="row">
                  <div class="col-3 text-right mb-2">
                    <b>住家電話</b>
                  </div>
                  <div class="col-9 item-content mb-2">
                    <div class="content">
                      <span class="text">{{customer.phone.value}}</span>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="customer.phone.newValue">
                  <div class="col-3 text-right">
                    <span class="arrow m-0">❯</span>
                  </div>
                  <div class="col-9 item-content">
                    <div class="content">
                      <span class="text text-red">
                        <b class="text m-0 p-0">{{ customer.phone.newValue }}</b>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="mr-0 checkbox checkbox-inline" v-if="customer.phone.newValue">
                  <input type="checkbox" id="check-out-phone" v-model="customer.phone.isSync"/>
                  <label :for="`check-out-phone`">同步更新</label>
                </div>
              </div>
            </div>
            <div class="row item update-info" :class="{'is-isSync':customer.address.newValue}">
              <div class="col-9">
                <div class="row">
                  <div class="col-3 text-right mb-2">
                    <b>住家地址</b>
                  </div>
                  <div class="col-9 item-content mb-2">
                    <div class="content">
                      <span class="text">{{customer.address.value}}</span>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="customer.address.newValue">
                  <div class="col-3 text-right">
                    <span class="arrow m-0">❯</span>
                  </div>
                  <div class="col-9 item-content">
                    <div class="content">
                      <span class="text text-red">
                        <b class="text m-0 p-0">{{customer.address.newValue }}</b>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="mr-0 checkbox checkbox-inline" v-if="customer.address.newValue">
                  <input type="checkbox" id="check-out-address" v-model="customer.address.isSync"/>
                  <label :for="`check-out-address`">同步更新</label>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 action mt-4 text-right p-0"  v-if="custMsgInfo.sub_trn_kind == 'ABQCID'">
              <a ref="btn_submit" @click="doSubmit" class="btn btn-primary">更新</a>
            </div>
            <div class="col-12 action mt-4 text-right p-0"  v-else>
              <a ref="btn_cancel" @click="$emit('close')" class="btn btn-default">取消</a>
              <a ref="btn_submit" @click="doSubmit" class="btn btn-primary">確定</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { selectMsgCustInfo,queryh013} from "../../service";
import { updCustMsgCust } from "../../service";

export default {
  name: "UpdateMsgModal",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    custMsgInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      customer: {
        name: {
          value: "",
          newValue:"",
          isSync:false
        },
        identityID: {
          value: "",
          newValue:"",
          isSync:false
        },
        birthday: {
          value: "",
          newValue:"",
          isSync:false
        },
        mobile: {
          value: "",
          newValue:"",
          isSync:false
        },
        phone: {
          value: "",
          newValue:"",
          isSync:false
        },
        address: {
          value: "",
          newValue:"",
          isSync:false
        }
      },
      isLoading: false,
      type:''
    };
  },
  watch: {
    open(val) {
      if (val) {
        this.init();
        this.getCustInfo();      
      }
    }
  },
  methods: {
    getCustInfo() {      
      if (this.custMsgInfo) {
        if(this.custMsgInfo.kind ==="012"){
          this.type = '保全變更'
        }else{
          this.type = '成立新契約'
          queryh013(this.$store.state.userInfo.id, this.custMsgInfo.id).then(
            result => {
              if (result.header.status === "200" && result.body) {
                let change_list = result.body.change_list || []
                change_list.forEach(ele => {
                  
                  //姓名
                  if(ele.sub_trn_kind === 'AT_NM') {
                    this.customer.name.newValue = ele.aft_data
                    this.customer.name.isSync = true
                    this.customer.name.eft_date = ele.eft_date
                    this.customer.name.policy_no = ele.policy_no
                    this.customer.name.sub_trn_kind = ele.sub_trn_kind
                  }
                  //手機
                  if(ele.sub_trn_kind === 'AT_MOB') {
                    this.customer.mobile.newValue = ele.aft_data
                    this.customer.mobile.isSync = true
                    this.customer.mobile.eft_date = ele.eft_date
                    this.customer.mobile.policy_no = ele.policy_no
                    this.customer.mobile.sub_trn_kind = ele.sub_trn_kind
                  }
                  //電話
                  if(ele.sub_trn_kind === 'AT_TEL') {
                    this.customer.phone.newValue = ele.aft_data
                    this.customer.phone.isSync = true
                    this.customer.phone.home_tel_area = ele.home_tel_area
                    this.customer.phone.home_tel = ele.home_tel
                    this.customer.phone.eft_date = ele.eft_date
                    this.customer.phone.policy_no = ele.policy_no
                    this.customer.phone.sub_trn_kind = ele.sub_trn_kind
                  }
                   //地址
                  if(ele.sub_trn_kind === 'AT_ADDR') {
                    this.customer.address.newValue = ele.aft_data
                    this.customer.address.isSync = true
                    this.customer.address.home_addr1 = ele.home_addr1
                    this.customer.address.home_addr2 = ele.home_addr2
                    this.customer.address.home_addr3 = ele.home_addr3
                    this.customer.address.home_addr_zip = ele.home_addr_zip
                    this.customer.address.eft_date = ele.eft_date
                    this.customer.address.policy_no = ele.policy_no
                    this.customer.address.sub_trn_kind = ele.sub_trn_kind
                  }

                  //生日
                  if(ele.sub_trn_kind === 'AT_BIR') {
                    this.customer.birthday.newValue = ele.aft_data
                    this.customer.birthday.isSync = true
                    this.customer.birthday.eft_date = ele.eft_date
                    this.customer.birthday.policy_no = ele.policy_no
                    this.customer.birthday.sub_trn_kind = ele.sub_trn_kind 
                  }

                })
                            
              } else {
                this.$toast.info({ title: result.header.message });
              }
            }
          );
        }
        this.isLoading = true;
        selectMsgCustInfo(this.$store.state.userInfo.id, this.custMsgInfo.id).then(
          result => {
            if (result.header.status === "200" && result.body) {
              let queryInfo = result.body || {}
              this.customer.name.value = queryInfo.name //姓名
              this.customer.identityID.value = queryInfo.id //ID
              this.customer.birthday.value = queryInfo.birthday //生日
              this.customer.mobile.value = queryInfo.mobile //手機
              if(queryInfo.home_tel_area || queryInfo.home_tel) {
              this.customer.phone.value = queryInfo.home_tel_area + '-' + queryInfo.home_tel
              } else {
                this.customer.phone.value = ''
              }
              this.customer.address.value = queryInfo.home_addr1 + queryInfo.home_addr2 + queryInfo.home_addr3

              //保全變更判斷
              if(this.custMsgInfo.sub_trn_kind === 'ABQCID') {
                this.customer.identityID.newValue = this.custMsgInfo.aft_data
                this.customer.identityID.eft_date = this.custMsgInfo.eft_date
                this.customer.identityID.sub_trn_kind = this.custMsgInfo.sub_trn_kind
                this.customer.identityID.isSync = false
              }
              if(this.custMsgInfo.sub_trn_kind === 'ABQCNM') {
                this.customer.name.newValue = this.custMsgInfo.aft_name
                this.customer.name.eft_date = this.custMsgInfo.eft_date
                this.customer.name.sub_trn_kind = this.custMsgInfo.sub_trn_kind
                this.customer.name.isSync = true
              }
              
            } else {
              this.$toast.info({ title: result.header.message });
            }
            this.isLoading = false;
            this.registerHanlink(); // for 難字 update
          }
        );
      }
    },
    doSubmit() {
      this.isLoading = true;
      const updateInfo = {};
      Object.keys(this.customer).forEach(key => {
        if (key === "changeType") {
          return;
        }        
        //有新值且確認要更新
        if (this.customer[key].newValue && this.customer[key].isSync) {
          this.customer[key].confirm_type = '1'
        } else if(this.customer[key].newValue && !this.customer[key].isSync){
          //有新值但不更新
          this.customer[key].confirm_type = '2'
        }
      });

      updCustMsgCust(this.$store.state.userInfo.id, this.customer,this.customer.identityID.value).then(result => {
        if (result.header && result.header.status == "200") {
          this.$toast.info({ title: result.header.message });
          this.$emit("submit");
        } else {
          this.$toast.info({ title: "連線異常,請稍候再試" });
        }
        this.isLoading = false;
      });
    },
    init(){
       Object.keys(this.customer).forEach(key => {      
         Object.keys(this.customer[key]).forEach(each => {      
           this.customer[key][each] =''
        });
      });

    }
  }
};
</script>
<style lang="scss" scoped>
.btn {
  width: 120px;
}

.modal.fade.is-open {
  display: block;
  max-height: 100vh;
  overflow: auto;
}

.modal.fade .modal-dialog.modal-sm {
  width: 640px;
  margin: 10% auto;
}

//不需要用到的樣式
/*.modal.fade .modal-header {
  display: flex;
  justify-content: center;
  background: #f5f5f5;
  padding: 20px 40px;
  border-radius: 12px 12px 0 0;
}

.modal.fade .modal-header .modal-title {
  margin: 0;
  text-align: center;
  color: #323a45;
  font-size: 20px;
  font-weight: normal;
  line-height: 1.65;
  letter-spacing: normal;
}*/

.text.text-red b {
  font-weight: bolder;
  color: #d52572;
}

.checkbox input:checked + label {
  color: #d52572;
}

.checkbox input:checked + label:before {
  border-color: #d52572;
  color: #d52572;
}

span.arrow {
  color: #d52572;

  &:before {
    background: #d52572;
  }
}

.update-info {
  border-bottom: 1px solid #e7e7e7;

  &.is-isSync {
    background: #feeddc;
  }
}

.customer-conetnt-wrapper {
  overflow-y: inherit;
}
</style>